<div class="file-upload-container" appDnd (fileDropped)="onFileDropped($event)">
    <input type="file" #fileDropRef id="fileDropRef" multiple
           (change)="fileBrowseHandler($event.target.files)" [accept]="acceptedFileTypes"
           [attr.maxFileSize]="maxFileSize" />
    <h3>Drag and drop your file(s) here</h3>
    <h3>or</h3>
    <label for="fileDropRef" style="color: #419154;"><b>Browse</b></label>
    <small style="margin-top: 8px;">{{acceptedFileTypes}}</small>
  </div>
  
  <div class="files-list">
    <div class="single-file" *ngFor="let file of files; let i = index">
      <img [src]="file.url" *ngIf="file.type.startsWith('image')" width="50">
      <div class="file-name">{{file.name}}</div>
      <div class="file-size">{{formatBytes(file.size)}}</div>
      <div class="file-actions">
        <p-button icon="pi pi-times" pTooltip="Remove" tooltipPosition="bottom"
                  (click)="deleteFile(i);"></p-button>
      </div>
    </div>
  </div>